import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-0 text-caption text-muted" }

import { appVersion } from "@/utils/appVersion";

export default /*@__PURE__*/_defineComponent({
  __name: 'VersionComponent',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_unref(appVersion)), 1))
}
}

})